import { render } from "./VendorPeriodTable.vue?vue&type=template&id=57f1219e"
import script from "./VendorPeriodTable.vue?vue&type=script&lang=js"
export * from "./VendorPeriodTable.vue?vue&type=script&lang=js"

import "./VendorPeriodTable.vue?vue&type=style&index=0&id=57f1219e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__